module.exports = __webpack_public_path__ + "img/jacket.69bd1758.png";